import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './yearbook05.css';
import { FaTrophy, FaHandshake, FaMicrochip, FaUserPlus, FaQuoteLeft, FaRocket, FaHeart, FaGlobe, FaUsers, FaSyncAlt, FaFlask, FaDatabase, FaChartLine, FaMapMarkerAlt, FaLightbulb, FaGamepad, FaBirthdayCake, FaOm, FaSnowflake, FaDumbbell, FaBullseye, FaDollarSign, FaBinoculars, FaMedal, FaStar, FaUserTie, FaCrown, FaBriefcase, FaCommentDots, FaBuilding } from 'react-icons/fa';
import heroBg from '../../assets/images/banner/about-banner.png';

import wins1 from '../../assets/images/Yearbook/Our Wins/1 Good Sam.jpg';
import wins2 from '../../assets/images/Yearbook/Our Wins/2 RE brand-new-shiny-black-retro-chopper-is-parked-brick-building.jpg';
import wins3 from '../../assets/images/Yearbook/Our Wins/3 Real estate mumbai-city-skyline-aerial-panorama.jpg';
import wins4 from '../../assets/images/Yearbook/Our Wins/4 AIS glass building-architecture-office-window-contemporary-concept.jpg';
import wins5 from '../../assets/images/Yearbook/Our Wins/5 white-truck-crossing-bridge-sunset-urban-logistics-motion.jpg';
import wins6 from '../../assets/images/Yearbook/Our Wins/6 microbiologist-doctor-taking-blood-sample-tube-from-rack-with-machines-analysis-lab-background.jpg';
import wins7 from '../../assets/images/Yearbook/Our Wins/7 luxury-jewellery-display.jpg';
import wins8 from '../../assets/images/Yearbook/Our Wins/8 bank 360_F_808994683_OUZEZt581lOYP0H2zGRXMZKJ5g87jkjx.jpg';
import wins9 from '../../assets/images/Yearbook/Our Wins/9 mall.jpg';
import wins10 from '../../assets/images/Yearbook/Our Wins/10 hotel eef8369398e2d8ac1191ee20223f219f.jpg';
import wins11 from '../../assets/images/Yearbook/Our Wins/11 jazeeraairways.png';
import wins12 from '../../assets/images/Yearbook/Our Wins/12 livpure.png';
import wins13 from '../../assets/images/Yearbook/Our Wins/13 godrej.jpg';
import wins14 from '../../assets/images/Yearbook/Our Wins/14 lodha.jpg';
import wins15 from '../../assets/images/Yearbook/Our Wins/15 pidilite.jpg';
import wins16 from '../../assets/images/Yearbook/Our Wins/16 golf.jpg';
import wins17 from '../../assets/images/Yearbook/Our Wins/17 abharan.jpg';
import wins18 from '../../assets/images/Yearbook/Our Wins/18 parag foods.jpg';
import wins19 from '../../assets/images/Yearbook/Our Wins/19 godrej.jpg';
import wins20 from '../../assets/images/Yearbook/Our Wins/20 scaler academy.jpg';
import wins21 from '../../assets/images/Yearbook/Our Wins/21 renewals.jpg';
import wins22 from '../../assets/images/Yearbook/Our Wins/22 AI avtaar kiosk.jpeg';
import wins23 from '../../assets/images/Yearbook/Our Wins/23 pro league soccer-players-action-professional-stadium.jpg';
import wins24 from '../../assets/images/Yearbook/Our Wins/24 modern-interior-design-interior.jpg';
import gitex from '../../assets/images/Yearbook/2 Business News & Events/11 GITEX.jfif';
import gecPuneImg from '../../assets/images/Yearbook/2 Business News & Events/1 GEC Pune.jpg';
import anandDeshpandeImg from '../../assets/images/Yearbook/2 Business News & Events/2 Anand Deshpande.jpg';
import reciImg from '../../assets/images/Yearbook/2 Business News & Events/3 RECI.JPG';
import agentforceDubaiImg from '../../assets/images/Yearbook/2 Business News & Events/4 Agentforce Dubai.jpeg';
import netcoreEgyptImg from '../../assets/images/Yearbook/2 Business News & Events/5 Netcore Egypt.jfif';
import agentforceMumbaiImg from '../../assets/images/Yearbook/2 Business News & Events/6 Agentforce Mumbai.jfif';
import gecDubaiImg from '../../assets/images/Yearbook/2 Business News & Events/7 GEC Dubai.jfif';
import etCioImg from '../../assets/images/Yearbook/2 Business News & Events/8 ET cio.jpg';
import orraImg from '../../assets/images/Yearbook/2 Business News & Events/9 Orra.JPG';
import dreamforceImg from '../../assets/images/Yearbook/2 Business News & Events/10 Dreamforce 1.JPEG';
import sachinImg from '../../assets/images/Yearbook/Welcome Onboard/Welcome Sachin Itkar.jfif';
import rupeshImg from '../../assets/images/Yearbook/Welcome Onboard/Welcome Rupesh Kulkarni.jpg';
import sushilChawlaImg from '../../assets/images/Yearbook/Welcome Onboard/Welcome Sushil Chawla.jpeg';
import gauriImg from '../../assets/images/Yearbook/Associates Speak_Gauri.jpg';
import radhaImg from '../../assets/images/Yearbook/Associates Speak_Radha.JPG';
import daajiImg from '../../assets/images/Yearbook/Daaji.jpg';
import sushilGujrathiImg from '../../assets/images/Yearbook/sushil.png';
import sankrantiImg from '../../assets/images/Yearbook/3 In- House Enrichment and Revelry/Collage 1 Sankranti.jpg';
import carromImg from '../../assets/images/Yearbook/3 In- House Enrichment and Revelry/Collage 2 Carrom competition.jpg';
import picnicImg from '../../assets/images/Yearbook/3 In- House Enrichment and Revelry/Collage 3 Annual picnic.jpg';
import navratriImg from '../../assets/images/Yearbook/3 In- House Enrichment and Revelry/Collage 4 Navratri.jpg';
import diwaliImg from '../../assets/images/Yearbook/3 In- House Enrichment and Revelry/Collage 5 Diwali.jpg';
import plankImg from '../../assets/images/Yearbook/3 In- House Enrichment and Revelry/Collage 6 Plank challenge.jpg';
import teamDinnersImg from '../../assets/images/Yearbook/3 In- House Enrichment and Revelry/Collage 7 Team dinners.jpg';
import christmasImg from '../../assets/images/Yearbook/3 In- House Enrichment and Revelry/Collage 8 Christmas.jpg';
import celebratingFoundersImg from '../../assets/images/Yearbook/3 In- House Enrichment and Revelry/CelebratingCoFounders.png';
import celebratingSuccessImg from '../../assets/images/Yearbook/3 In- House Enrichment and Revelry/Celebrating Success together.jpeg';


const Yearbook05 = () => {
    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (
        <div className="yearbook-container">
            {/* Hero Section */}
            <section className="yb-hero" style={{ backgroundImage: `url(${heroBg})` }}>
                <div className="yb-hero-overlay"></div>
                <Container className="position-relative" style={{ zIndex: 2 }}>
                    <div className="yb-title">In Focus</div>
                    <div className="yb-hero-year">2025</div>
                    <div className="yb-hero-subtitle">YEARBOOK</div>
                    <div className="yb-hero-tagline">Reliving Memories, Celebrating Success</div>
                    <div className="mt-3">
                        <small className="text-muted text-white-50">INTERNAL NEWSLETTER</small>
                    </div>
                </Container>
            </section>

            {/* CEO Message */}
            <section className="yb-section">
                <Container>
                    <div className="text-center mb-4">
                        <span className="yb-pill-badge">
                            <FaQuoteLeft className="me-2" size={14} /> Leadership Message
                        </span>
                    </div>
                    <h2 className="yb-heading">From The CEO's Desk</h2>
                    <div className="yb-heading-underline"></div>

                    <div className="yb-ceo-msg">
                        <div className="yb-quote-icon">
                            <FaQuoteLeft />
                        </div>
                        <div className="yb-msg-content">
                            <p className="fw-bold fs-5 mb-4 text-danger">Dear Readers,</p>

                            <p>
                                As we look back on the year gone by, I feel a deep sense of pride and gratitude for what we have built together at Comsense. 2025 has been a year of momentum, marked by meaningful growth, stronger partnerships, and a clear sharpening of our purpose.
                            </p>

                            <p>
                                Across geographies including India, the US, the UAE, and emerging markets, we delivered impactful outcomes for clients across industries. Our progress within the Salesforce ecosystem, deeper collaborations with partners like Netcore, and growing AI and analytics capabilities reflect our commitment to building future-ready solutions that create real business value. These wins were not just about technology but about trust, execution, and long-term relationships.
                            </p>

                            <p>
                                Equally important was our focus inward. From leadership offsites and learning initiatives to milestone celebrations and team-led innovation, this year reinforced the culture that defines Comsense—one rooted in ownership, collaboration, and continuous learning. Welcoming experienced leaders and advisors into our ecosystem has further strengthened our ability to think strategically while executing with agility.
                            </p>

                            <p>
                                Events, industry forums, and global platforms such as Dreamforce, GITEX, GEC Dubai, and Agentforce gave us valuable perspectives on where technology and our clients are headed. One message stood out consistently: AI is no longer optional. It is foundational. And we are committed to translating this shift into tangible, responsible, and scalable outcomes for our clients.
                            </p>

                            <p>
                                None of this would be possible without the dedication of our teams, the trust of our clients, and the belief of our partners. Thank you for walking this journey with us. As we move forward, we do so with clarity, confidence, and a strong sense of purpose. We are ready to build what's next, together.
                            </p>

                            <div className="yb-divider"></div>

                            <div className="yb-signature d-flex align-items-center gap-3">
                                <img src={sushilGujrathiImg} alt="Sushil Gujrathi" className="rounded-circle shadow-sm" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                                <div>
                                    <div className="fw-bold mb-1">Regards</div>
                                    <div className="yb-sig-name">Sushil Gujrathi</div>
                                    <div className="yb-sig-title">CEO, Comsense Technologies</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            {/* Stats Section */}
            <section className="yb-section yb-stats-section">
                <Container>
                    <div className="text-center mb-3">
                        <span className="yb-badge-soft yb-badge-soft2">
                            <FaChartLine className="me-2 text-danger" /> Performance Metrics
                        </span>

                    </div>
                    <h2 className="yb-heading mb-3">2025 At A Glance</h2>
                    <div className="yb-heading-underline"></div>
                    <p className="yb-subtitle mx-auto" style={{ maxWidth: '800px' }}>A snapshot of our growth and achievements</p>
                    <Row className="g-4 justify-content-center">
                        {[
                            { icon: <FaGlobe />, num: '4', label: 'Countries Served' },
                            { icon: <FaUsers />, num: '24', label: 'New Client Partnerships' },
                            { icon: <FaSyncAlt />, num: '3', label: 'Multi-Year Renewals' },
                            { icon: <FaFlask />, num: '5+', label: 'AI-Led Engagements' },
                            { icon: <FaDatabase />, num: 'Multiple', label: 'Data Cloud & CDP Implementations' },
                            { icon: <FaChartLine />, num: '3', label: 'Core Industries: Retail, BFSI & E-Commerce' }
                        ].map((stat, idx) => (
                            <Col key={idx} md={4} sm={6}>
                                <div className="yb-stat-modern-card">
                                    <div className="yb-stat-icon">{stat.icon}</div>
                                    <div className="yb-stat-content">
                                        <div className="yb-stat-number">{stat.num}</div>
                                        <div className="yb-stat-label">{stat.label}</div>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                    <div className="yb-core-focus text-center">
                        <h4 className="mb-3 text-center">Core Focus Areas</h4>
                        <div className="d-flex flex-wrap justify-content-center">
                            {['Salesforce', 'Data Cloud', 'MarTech', 'AI', 'Analytics'].map((chip, idx) => (
                                <span key={idx} className="yb-chip">{chip}</span>
                            ))}
                        </div>
                    </div>
                </Container>
            </section>

            {/* Wins Section */}
            <section className="yb-section pt-0">
                <Container>
                    <div className="text-center mb-3">
                        <span className="yb-badge-soft">
                            <FaTrophy className="me-2 text-danger" /> Achievements
                        </span>
                    </div>
                    <h2 className="yb-heading mb-3">Our Wins</h2>
                    <div className="yb-heading-underline"></div>
                    <p className="yb-subtitle mx-auto" style={{ maxWidth: '900px' }}>
                        This year has been one of strong momentum and meaningful growth for us. We recorded several wins across key geographies including the US, UAE, and India, partnering with clients across diverse industries and business stages. From scaling our capabilities to delivering measurable impact, each engagement reinforced our commitment to innovation, agility, and customer-centric solutions. These wins reflect not just business success, but the trust our clients place in us. Here’s a quick snapshot of all our wins -
                    </p>

                    <Row className="g-4">
                        {/* Q1 Section - Full Width with Images */}
                        <Col md={12}>
                            <div className="d-flex align-items-center mb-4">
                                <div className="yb-win-icon"><FaHandshake /></div>
                                <div className="ms-3">
                                    <h4 className="fw-bold mb-0 pb-0">Jan - Mar 2025</h4>
                                </div>
                            </div>

                            <Slider {...sliderSettings} className="mb-3">
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins1} className="yb-win-img-bg" alt="Insurance" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Insurance</span>
                                            <div className="yb-win-img-title">Comsense Technologies Wins a Deal from A Leading Travel and Vehicular Insurance Company in the US</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins2} className="yb-win-img-bg" alt="Automotive" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Automotive</span>
                                            <div className="yb-win-img-title">New Business Added with A Globally Recognized Motorcycle Manufacturer</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins3} className="yb-win-img-bg" alt="Real Estate" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Real Estate</span>
                                            <div className="yb-win-img-title">A Deal from a Premium Indian Real Estate Developer</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins4} className="yb-win-img-bg" alt="Manufacturing" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Manufacturing</span>
                                            <div className="yb-win-img-title">New Deal from India’s Leading Integrated Glass and Windows Solution Company</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins5} className="yb-win-img-bg" alt="Automobile Logistics" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Automobile</span>
                                            <div className="yb-win-img-title">Add On Projects from The Largest Automobile Manufacturer</div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </Col>

                        <Col md={12}>
                            <div className="d-flex align-items-center mb-4">
                                <div className="yb-win-icon"><FaMicrochip /></div>
                                <div className="ms-3">
                                    <h4 className="fw-bold mb-0 pb-0">Apr - Jun 2025</h4>
                                </div>
                            </div>

                            <Slider {...sliderSettings} className="mb-3">
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins6} className="yb-win-img-bg" alt="Diagnostic and CDP" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Healthcare</span>
                                            <div className="yb-win-img-title">Customer Data Platform implementation for one of the Leading Diagnostic Company in India</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins7} className="yb-win-img-bg" alt="Jewellery" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Jewellery</span>
                                            <div className="yb-win-img-title">Salesforce full stack implementation for one of the most Dominant Jewellery Brands in India</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins8} className="yb-win-img-bg" alt="Banking" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Banking</span>
                                            <div className="yb-win-img-title">MarTech Stack Evaluation for one of the leading Banks of Egypt</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins9} className="yb-win-img-bg" alt="Mall" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Retail</span>
                                            <div className="yb-win-img-title">Driving SFMC Adoption & WhatsApp Integration for a Leading Premium Mall in India</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins10} className="yb-win-img-bg" alt="Hospitality" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Hospitality</span>
                                            <div className="yb-win-img-title">Marketing Campaigns for one of South Asias largest hospitality company</div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </Col>

                        <Col md={12}>
                            <div className="d-flex align-items-center mb-4">
                                <div className="yb-win-icon"><FaChartLine /></div>
                                <div className="ms-3">
                                    <h4 className="fw-bold mb-0 pb-0">Jul - Sep 2025</h4>
                                </div>
                            </div>

                            <Slider {...sliderSettings} className="mb-3">
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins11} className="yb-win-img-bg" alt="Aviation" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Aviation</span>
                                            <div className="yb-win-img-title">Won a Strategic Deal with a Top Aviation Company</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins12} className="yb-win-img-bg" alt="Water Purifier" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Consumer</span>
                                            <div className="yb-win-img-title">Became a Part of the Digital Transformation Journey of a Leading Indian Water Purifier Company</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins14} className="yb-win-img-bg" alt="Real Estate Data Cloud" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Real Estate</span>
                                            <div className="yb-win-img-title">Collaborated with a Leading Real Estate Company to Implement Salesforce Data Cloud</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins13} className="yb-win-img-bg" alt="Data Science" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Analytics</span>
                                            <div className="yb-win-img-title">Awarded an Opportunity to Expand Data Science Line of Business with a Reputed Real Estate Company</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins15} className="yb-win-img-bg" alt="Adhesives" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Manufacturing</span>
                                            <div className="yb-win-img-title">Won a MarTech Transformation Deal with a Market Leader in Adhesives</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins16} className="yb-win-img-bg" alt="Golf" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Sports</span>
                                            <div className="yb-win-img-title">A Win to Deliver AI-Driven Innovation for a Prominent Golf Brand</div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </Col>

                        <Col md={12}>
                            <div className="d-flex align-items-center mb-4">
                                <div className="yb-win-icon"><FaRocket /></div>
                                <div className="ms-3">
                                    <h4 className="fw-bold mb-0 pb-0">Oct - Dec 2025</h4>
                                </div>
                            </div>

                            <Slider {...sliderSettings} className="mb-3">
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins17} className="yb-win-img-bg" alt="Jewellery Data Cloud" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Jewellery</span>
                                            <div className="yb-win-img-title">Salesforce Data Cloud and Marketing Cloud implementation deal for a leading jewellery brand</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins18} className="yb-win-img-bg" alt="Sports Nutrition" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Nutrition</span>
                                            <div className="yb-win-img-title">Won a deal for Salesforce Data Cloud and Marketing cloud implementation for a leading sports nutrition brand</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins19} className="yb-win-img-bg" alt="Real Estate Managed Services" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Real Estate</span>
                                            <div className="yb-win-img-title">Awarded an opportunity to implement Marketing Cloud and provide managed services for a prominent real estate company</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins20} className="yb-win-img-bg" alt="EdTech" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">EdTech</span>
                                            <div className="yb-win-img-title">A Marketing Cloud implementation for a popular online tech education platform</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins21} className="yb-win-img-bg" alt="Renewals" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Renewals</span>
                                            <div className="yb-win-img-title">Project renewals for 3 prominent and trustworthy clients for the next 2 years</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins22} className="yb-win-img-bg" alt="AI Avatar Kiosk" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">AI</span>
                                            <div className="yb-win-img-title">AI Avatar on kiosk using Arabic & English for speech-driven interaction in real time for a Middle Eastern Organization</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins23} className="yb-win-img-bg" alt="Pro League Insights" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">Sports</span>
                                            <div className="yb-win-img-title">A phenomenal deal for data consolidation and building a single source of truth to drive pro league data driven insights</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="px-2">
                                    <div className="yb-win-img-card">
                                        <img src={wins24} className="yb-win-img-bg" alt="Interior Design Platform" />
                                        <div className="yb-win-img-overlay">
                                            <span className="yb-win-img-tag">UAE</span>
                                            <div className="yb-win-img-title">A deal to create web platform for real time selection and configuration of interior designing for a premium Interior design and manufacturing organization in UAE.</div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Partners Section */}
            <section className="yb-section pt-0">
                <Container>
                    <div className="text-center mb-3">
                        <span className="yb-badge-soft">
                            <FaHandshake className="me-2 text-danger" /> Strategic Partnerships
                        </span>
                    </div>
                    <h2 className="yb-heading mb-3">Our Growth Journey with Our Partners</h2>
                    <div className="yb-heading-underline"></div>
                    <p className="yb-subtitle mx-auto mb-5" style={{ maxWidth: '700px' }}>
                        Building a partner-first, consulting-led ecosystem that enables enterprises to scale faster and adopt smarter technologies
                    </p>

                    <div className="bg-white p-5 mb-5 text-center" style={{
                        padding: '24px',
                        borderRadius: '16px',
                        boxShadow: '0 5px 15px rgba(0,0,0,0.05);'
                    }}>
                        <p className="mb-3">
                            This year marked a significant step forward in how we built, deepened, and scaled our partnership ecosystem. At Comsense, partnerships are not transactional; they are strategic relationships rooted in shared purpose, co-innovation, and long-term value creation.
                        </p>
                        <p className="mb-0">
                            Our focus remained on building a partner-first, consulting-led ecosystem that enables enterprises to scale faster, adopt smarter technologies, and deliver meaningful customer experiences across markets.
                        </p>
                    </div>

                    <Row className="g-4 mb-5">
                        <Col md={6}>
                            <div className="yb-partner-wide-card">
                                <div className="yb-partner-icon-circle"><FaTrophy /></div>
                                <div className="yb-partner-text">Achieved multi-level progression within the Salesforce Partner ecosystem, advancing from Base to Ridge to Crest Partner in 2025</div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="yb-partner-wide-card">
                                <div className="yb-partner-icon-circle"><FaRocket /></div>
                                <div className="yb-partner-text">Delivered enterprise-grade implementations across diverse industries including Retail, BFSI, Real Estate, and Automobile</div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="yb-partner-wide-card">
                                <div className="yb-partner-icon-circle"><FaHandshake /></div>
                                <div className="yb-partner-text">Deepened strategic collaboration with Netcore, enabling advanced CDP-led insights and omnichannel engagement</div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="yb-partner-wide-card">
                                <div className="yb-partner-icon-circle"><FaChartLine /></div>
                                <div className="yb-partner-text">Strengthened our AI and analytics ecosystem with predictive modeling and intelligent automation</div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="yb-partner-wide-card">
                                <div className="yb-partner-icon-circle"><FaGlobe /></div>
                                <div className="yb-partner-text">Expanded partner-driven engagements across India, USA, UAE, and Egypt</div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="yb-partner-wide-card">
                                <div className="yb-partner-icon-circle"><FaRocket /></div>
                                <div className="yb-partner-text">Scaled consulting-led, long-term transformation roadmaps for sustained business impact</div>
                            </div>
                        </Col>
                    </Row>

                    <div className="yb-red-footer-bar">
                        Together, these partnerships have enabled us to deliver more integrated, intelligent, and outcome-driven solutions. This lays a strong foundation for collaborative growth in the years ahead.
                    </div>
                </Container>
            </section>

            {/* Events Section */}
            <section className="yb-section pt-2">
                <Container>
                    <div className="text-center mb-3">
                        <span className="yb-badge-soft">
                            <FaGlobe className="me-2 text-danger" /> Global Presence
                        </span>
                    </div>
                    <h2 className="yb-heading mb-3">Business Events & News</h2>
                    <div className="yb-heading-underline"></div>
                    <p className="yb-subtitle mx-auto mb-5" style={{ maxWidth: '700px' }}>
                        Engaging with global leaders and showcasing innovation worldwide
                    </p>

                    <Row className="g-4">
                        {[
                            {
                                title: 'Global Entrepreneurs Conclave 2025',
                                location: 'Pune, India',
                                desc: "Comsense's leadership attended the Global Entrepreneurs Conclave 2025, held in Pune in January, centered on \"Transforming Insights into Action.\" The conclave brought together over 1,000 participants. CEO Sushil hosted an exclusive session introducing Revenue Accelerator Technology for MSMEs.",
                                img: gecPuneImg
                            },
                            {
                                title: 'Sagar Babar Appointed Director – Rural Entrepreneurs’ Connect Initiative (RECI)',
                                location: 'Pune, India',
                                desc: 'Comsense’s President and Chief AI officer, Sagar Babar, became a Director of the newly launched Rural Entrepreneurs’ Connect Initiative (RECI)—a social initiative aimed at empowering rural entrepreneurs across Maharashtra. Launched on April 1, 2025, in Pune, RECI brings together industry leaders, changemakers, and entrepreneurs to bridge gaps, spark innovation, and build a strong collaborative ecosystem for rural businesses. The launch event marked an important step toward inclusive and sustainable entrepreneurship.',
                                img: reciImg
                            },
                            {
                                title: 'A Meeting of Minds: Comsense President and Chief AI Officer Sagar Babar in Conversation with Anand Deshpande',
                                location: 'Pune, India',
                                desc: 'One of the most inspiring moments at the Global Entrepreneurs Conclave was the engaging conversation between Comsense President and Chief AI Officer, Sagar Babar, and Anand Deshpande, Founder and Chairman of Persistent Systems. The discussion offered valuable insights for budding entrepreneurs, highlighting the importance of starting local before scaling globally, identifying a clear niche, building strong teams, and mastering the art of selling. The exchange was both insightful and motivating, leaving the audience with practical takeaways for sustainable growth.',
                                img: anandDeshpandeImg
                            },

                            {
                                title: 'Agentforce World Tour Dubai: Insights, Innovation, and Global Connections',
                                location: 'Dubai, UAE',
                                desc: "Comsense leadership was present at the Agentforce World Tour Dubai in May, with our CEO Sushil Gujrathi and Head of Business Vishnu Kamath attending the event. The forum offered valuable opportunities to engage with Salesforce professionals from across the globe and gain deeper insights into Salesforce’s evolving solutions and capabilities. Thought-provoking sessions combined with vibrant peer networking created an inspiring environment, equipping our team with perspectives that will further strengthen our Salesforce implementations and client outcomes.",
                                img: agentforceDubaiImg
                            },
                            {
                                title: 'Netcore MarTech Global Summit, Cairo: AI-Driven Customer Engagement in Focus',
                                location: 'Cairo, Egypt',
                                desc: "Our CEO, Sushil Gujrathi, attended Netcore’s MarTech Global Summit in Cairo, Egypt. It was an insightful forum centred on how AI is transforming every stage of customer engagement. The event offered deep, practical perspectives on zero-guesswork marketing, smarter ROI-driven customer journeys, and strategies that are not just conceptual but actively delivering results in 2025. The discussions reinforced the growing role of AI in shaping measurable and impactful marketing outcomes.",
                                img: netcoreEgyptImg
                            },
                            {
                                title: 'Agentforce World Tour Mumbai: Leadership, Innovation, and Inspiration',
                                location: 'Mumbai, India',
                                desc: 'Comsense’s leadership team and BU Heads attended the Agentforce World Tour hosted by Salesforce at BKC, Mumbai. The event featured expert-led sessions and product demonstrations across industries, offering insights into the latest Salesforce innovations. Arundhati Bhattacharya, Chairperson and CEO of Salesforce India, highlighted the role of leadership and adaptability in a rapidly evolving digital landscape. An engaging conversation between Arun Kumar Parameswaran and Sania Mirza on resilience, reinvention, and high performance added a powerful perspective, making the event a valuable learning and networking experience for our team.',
                                img: agentforceMumbaiImg
                            },
                            {
                                title: 'GEC Dubai 2025: Advancing AI Partnerships and Workforce Readiness',
                                location: 'Dubai, UAE',
                                desc: 'Comsense participated in GEC Dubai 2025, engaging with delegates, speakers, and industry leaders while showcasing our AI-ready solutions at the Comsense booth. The event provided a strong platform to exchange ideas, gain cross-industry insights, and explore collaborative opportunities with global innovators and policymakers. A key milestone during the event was the signing of an MoU with Sanbook Quality Consultancy to train and empower 1,000 professionals in AI across industries, reinforcing our commitment to building future-ready talent and driving sustainable, technology-led growth.',
                                img: gecDubaiImg
                            },
                            {
                                title: 'Retail Leaders’ Dialogue: Harnessing Data and AI for Customer Engagement',
                                location: 'Dubai, UAE',
                                desc: 'Comsense Co-founder Biju Nambiar spoke at the Retail in Motion: Industry Leaders’ Dialogue, sharing insights on how data and AI are reshaping customer engagement in the retail and consumer goods sectors. The session brought together industry leaders to discuss real-world use cases, connected ecosystems, and strategies for building trust and driving growth. Biju highlighted the impact of AI-led personalization, predictive analytics, and unified data platforms in creating seamless customer experiences, reinforcing Comsense’s commitment to turning data into actionable, business-ready intelligence.',
                                img: etCioImg
                            },
                            {
                                title: 'Dreamforce 2025: Where AI, Data, and Customer Experience Converge',
                                location: 'San Francisco, USA',
                                desc: 'Comsense leadership, Sagar Babar, Sushil Gujrathi, and Biju Nambiar, attended Dreamforce 2025, one of the world’s most influential technology conferences. More than just an event, Dreamforce offered a compelling view into the future of enterprise technology, with strong focus on AI, data, and customer experience. Conversations and demonstrations around Agentforce and Data Cloud highlighted how AI is no longer a supporting tool but a core foundation shaping how enterprises operate, innovate, and scale. The insights and connections from the conference will play a key role in translating global innovation into meaningful impact for our clients.',
                                img: dreamforceImg
                            },
                            {
                                title: 'GITEX Global Dubai: Showcasing AI-Driven Business Impact',
                                location: 'Dubai, UAE',
                                desc: 'Comsense participated in GITEX Global Dubai, engaging with visitors at our booth and demonstrating how we bridge the gap between technology and business. Our AI-powered solutions showcased how organizations can unlock growth, transform operations, and drive measurable outcomes through smarter decision-making and sustainable impact. The event provided a valuable platform to connect with industry leaders and innovators, reinforcing our commitment to delivering technology that creates real business value.',
                                img: gitex
                            },
                            {
                                title: 'Enabling Personalized Retail Experiences with Salesforce',
                                location: 'India',
                                desc: 'At a recent retail industry event, our client, a leading diamond and platinum jewellery brand, successfully went live on Salesforce as their core customer engagement platform. Comsense is driving the initiative by unifying customer data into a single source of truth, enabling seamless and personalized shopping journeys. The engagement also includes building management-level dashboards that deliver actionable insights, empowering leadership with faster decision-making while equipping sales and service teams to deliver exceptional in-store experiences.',
                                img: orraImg
                            },
                        ].map((event, idx) => (
                            <Col key={idx} md={6}>
                                <div className="yb-event-modern-card">
                                    <div className="yb-event-img-container">
                                        <div className="yb-event-pattern"></div>
                                        <img src={event.img} alt={event.title} className="yb-event-img" />
                                    </div>
                                    <div className="yb-event-body">
                                        <div className="yb-event-location">
                                            <FaMapMarkerAlt className="me-2" /> {event.location}
                                        </div>
                                        <h5 className="yb-event-title">{event.title}</h5>
                                        <p className="yb-event-desc">{event.desc}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* Internal News Section */}
            <section className="yb-section" style={{ background: 'linear-gradient(to bottom, #eef9fe 0%, #ffffff 100%)' }}>
                <Container>
                    <div className="text-center mb-3">
                        <span className="yb-badge-soft yb-badge-soft2">
                            <FaHeart className="me-2 text-danger" /> Culture & Celebrations
                        </span>
                    </div>
                    <h2 className="yb-heading mb-3">Internal News & Buzz</h2>
                    <div className="yb-heading-underline"></div>
                    <p className="yb-subtitle mx-auto mb-5" style={{ maxWidth: '700px' }}>
                        Celebrating moments, building connections, and fostering our vibrant culture
                    </p>

                    {/* Featured Red Card */}
                    <div className="yb-featured-red-card mb-5">
                        <div className="d-flex align-items-center mb-3">
                            <FaLightbulb className="yb-featured-icon me-3" />
                            <h3 className="mb-0 fw-bold text-white">AI Learning in Action</h3>
                        </div>
                        <p className="mb-0 text-white">
                            Comsense hosted an internal AI workshop led by Saurabh Shahane, Founder & CEO of The Machine Learning Company. The session focused on demystifying AI systems and introducing practical tools to enhance productivity. With active participation and high energy, the workshop reinforced our culture of continuous learning and innovation.
                        </p>
                    </div>

                    {/* Leadership Card */}
                    <div className="yb-leadership-card mb-5">
                        <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=1200" className="yb-leadership-img mb-4" alt="Leadership Meet" />
                        <h4 className="fw-bold mb-3">Leadership Meet: Aligning for What's Next</h4>
                        <p className="text-muted mb-3">
                            Comsense successfully concluded its Leadership Offsite, marked by thoughtful discussions, healthy debates, and fresh ideas. The offsite resulted in a simple yet powerful framework to guide decision-making—<span className="text-danger fw-bold">Start. Stop. Continue.</span>
                        </p>
                        <p className="text-muted mb-0">
                            The underlying principle was clear: starting something new requires consciously stopping something of equal or greater magnitude. This shared mantra is helping drive greater clarity, focus, and alignment across leadership.
                        </p>
                    </div>

                    {/* Website Revamp Card */}
                    <div className="yb-leadership-card mb-5">
                        <h4 className="fw-bold mb-3">Comsense Website Revamp</h4>
                        <p className="text-muted mb-0">
                            Comsense rolled out a refreshed version of its website this year, reflecting our evolving brand, capabilities, and vision for the future. The revamp focuses on clearer messaging, improved navigation, and a more modern design to better showcase our solutions, partnerships, and customer impact. The updated website aligns with our growth journey and enhances how we engage with clients, partners, and talent globally.
                        </p>
                    </div>

                    <h3 className="text-center fw-bold mb-5">In-House Enrichment and Revelry</h3>

                    <Row className="g-4 mb-5">
                        {[
                            { title: 'A Sky Full of Kites and Smiles', img: sankrantiImg, icon: <FaRocket />, desc: 'The Comsense Pune office celebrated Makar Sankranti with vibrant energy and festive cheer. Dressed in traditional attire, teams enjoyed festive treats and a lively kite-flying session from the office terrace, filling the sky with colorful kites, laughter, and friendly competition—making it a truly memorable celebration.' },
                            { title: 'Strikes, Smiles & Friendly Rivalries', img: carromImg, icon: <FaGamepad />, desc: 'The Comsense team came together for an in-house carrom competition, filled with enthusiasm, focus, and friendly banter. The games sparked healthy competition and team bonding, making it a refreshing break from routine and a reminder that great teamwork also grows beyond work.' },
                            { title: '10 Years Strong: A Weekend of Stories, Smiles & Celebration', img: picnicImg, icon: <FaBirthdayCake />, desc: 'In August, the Comsense team marked 10 years of growth and togetherness during our annual picnic at Karjat. Filled with laughter, bonding, and reflections on our journey, the celebration became even more special with the Leadership Awards, recognizing the outstanding contributions of Vishnu Kamath and Omkar Dhapte—a true reflection of the grit and passion that power Comsense.' },
                            { title: 'Nine Nights, One Team, Endless Festive Spirit', img: navratriImg, icon: <FaOm />, desc: 'Comsense celebrated Navratri with vibrant energy as teams came together in traditional attire for music, garba, and dandiya. The celebration filled the workplace with joy and color, strengthening connections and reflecting the unity and positivity at the heart of our culture.' },
                            { title: 'Lighting Up Comsense: Diwali Celebrations', img: diwaliImg, icon: <FaLightbulb />, desc: 'The Comsense office came alive with festive spirit as teams celebrated Diwali together. With traditional attire, decorations, sweets, and shared moments of joy, the celebration reflected togetherness, gratitude, and the positive energy that lights our journey forward.' },
                            { title: 'Planks, Power & Friday Night Cheers', img: plankImg, icon: <FaDumbbell />, desc: 'The Comsense Friday Plank Challenge brought energy, grit, and friendly rivalry to the office floor. Standout performances by Saurabh Kushwaha and Rutika B., both crossing the 6-minute mark, kept the excitement high, with the women’s team clinching a confident win. A perfect blend of fitness, fun, and team spirit to end the week strong.' },
                            { title: 'Celebrating Success, Together', img: celebratingSuccessImg, icon: <FaMedal />, desc: 'Staying true to our belief in celebrating every milestone, the Comsense team came together to mark the successful delivery of a major project. The moment was celebrated with a cake-cutting ceremony, reflecting the dedication, collaboration, and resilience that turned vision into reality. It turned out to be a proud and joyful occasion for all.' },
                            { title: 'Conversations Beyond the Conference Room', img: teamDinnersImg, icon: <FaCommentDots />, desc: 'Regular team dinners at Comsense create space to unwind, connect, and strengthen relationships beyond work. These shared moments help build camaraderie, deepen trust, and reinforce the sense of belonging that makes our teams stronger every day.' },
                            { title: 'Red, Cheer & Christmas Smiles', img: christmasImg, icon: <FaSnowflake />, desc: 'The Comsense office embraced the Christmas spirit, with teams dressed in red and spreading festive cheer all around. Laughter, togetherness, and joyful moments filled the day, making it a heartwarming celebration to end the year on a happy note.' },
                            { title: 'Celebrating Our Co-Founders', img: celebratingFoundersImg, icon: <FaBirthdayCake />, desc: 'The Comsense team came together to mark the birthdays of co-founders Biju Nambiar and Vineet Ladhania, alongside Vishnu Kamath, our Data Science Director. The celebration was filled with warm wishes and togetherness, highlighting gratitude, camaraderie, and the shared values that shape our organization.' }
                        ].map((item, idx) => (
                            <Col key={idx} md={6} sm={6}>
                                <div className="yb-culture-card">
                                    <div className="yb-culture-image-wrapper">
                                        <img src={item.img} alt={item.title} className="yb-culture-image" />
                                    </div>
                                    <div className="yb-culture-content">
                                        <div className="yb-culture-title-row">
                                            <div className="yb-culture-icon-circle">{item.icon}</div>
                                            <h6 className="yb-culture-title fw-bold mb-0">{item.title}</h6>
                                        </div>
                                        <p className="small text-muted mb-0 mt-2">{item.desc}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* Honouring Excellence Section */}
            <section className="yb-section yb-section-gradient">
                <Container>
                    <div className="text-center mb-3">
                        <span className="yb-badge-soft yb-badge-soft2">
                            <FaMedal className="me-2 text-danger" /> Recognition
                        </span>
                    </div>
                    <h2 className="yb-heading mb-3">Honouring Excellence</h2>
                    <div className="yb-heading-underline"></div>
                    <p className="yb-subtitle mx-auto mb-5" style={{ maxWidth: '800px' }}>
                        Comsense Recognition Awards celebrate the intent, ownership, collaboration, and commitment that drive our success
                    </p>

                    <div className="yb-excellence-featured">
                        <p className="mb-0 mx-auto" style={{ maxWidth: '900px', fontSize: '1.05rem', lineHeight: '1.6' }}>
                            At Comsense, excellence is measured not just by outcomes, but by the intent, ownership, collaboration, and commitment that go into achieving them. Our 10th Anniversary celebrations provided the perfect moment to honour individuals whose contributions stood out through the year.
                        </p>
                    </div>

                    <Row className="g-4">
                        {[
                            {
                                icon: <FaStar />,
                                title: "Rookie of the Year",
                                winners: ["Revati Vidhale", "Pranav Konde"]
                            },
                            {
                                icon: <FaMedal />,
                                title: "Star Performer",
                                winners: ["Vijay Pujari", "Wasim Miya", "Shreyash Pole"]
                            },
                            {
                                icon: <FaUserTie />,
                                title: "Ace Contributor",
                                winners: ["Khushi Sangirkar", "Payal Maisheri", "Suraj Mudliar"]
                            },
                            {
                                icon: <FaUsers />,
                                title: "Team Player",
                                winners: ["Srushti Labade", "Ritu Shah", "Akshay Waghmare", "Dipali More", "Amit Mandhare"]
                            },
                            {
                                icon: <FaHeart />,
                                title: "Customer Delight",
                                winners: ["Rutuja Rajput", "Pankaj Patil", "Rutika Bhikule"]
                            },
                            {
                                icon: <FaLightbulb />,
                                title: "Innovation Award",
                                winners: ["Swadhin Nagulpelli"]
                            },
                            {
                                icon: <FaCrown />,
                                title: "Special Admin Excellence",
                                winners: ["Sheetal Rao", "Sumedh Pawaskar", "Sumedh Natekar"]
                            }
                        ].map((award, idx) => (
                            <Col key={idx} md={6}>
                                <div className="yb-award-card">
                                    <div className="yb-award-icon">{award.icon}</div>
                                    <div>
                                        <h5 className="fw-bold mb-2">{award.title}</h5>
                                        <div className="yb-winner-tags">
                                            {award.winners.map((winner, wIdx) => (
                                                <span key={wIdx} className="yb-winner-tag">{winner}</span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>

                    <div className="yb-congrats-banner">
                        Each of these awardees exemplifies the values we stand for—ownership, collaboration, innovation, and customer-centricity. We extend our heartfelt congratulations to all the winners and thank them for setting benchmarks that inspire the entire Comsense community.                    </div>
                </Container>
            </section>



            {/* Welcome Onboard */}
            <section className="yb-section yb-section-gradient">
                <Container>
                    <div className="text-center mb-3">
                        <span className="yb-badge-soft yb-badge-soft2">
                            <FaUserPlus className="me-2 text-danger" /> Leadership Expansion
                        </span>
                    </div>
                    <h2 className="yb-heading">Welcome Onboard</h2>
                    <div className="yb-heading-underline"></div>
                    <p className="yb-subtitle mx-auto mb-5" style={{ maxWidth: '700px' }}>
                        New leaders bringing strategic vision, expertise, and execution mindset to shape our next phase of growth
                    </p>

                    <div className="yb-welcome-intro">
                        This year, Comsense strengthened not just its ground team but also its leadership bench with the addition of seasoned strategic advisors and regional Vice Presidents across key geographies. These leaders bring deep industry expertise, global perspectives, and a strong execution mindset that will help shape strategic direction, drive growth, and scale the organization responsibly.
                    </div>

                    <div className="mx-auto" style={{ maxWidth: '900px' }}>
                        <div className="yb-leader-card">
                            <img src={sachinImg} alt="Sachin Itkar" className="yb-leader-img-circle" />
                            <div className="yb-leader-content">
                                <h4>Sachin Itkar</h4>
                                <span className="yb-leader-role">Strategic Advisor</span>
                                <p className="yb-leader-desc">
                                    With extensive global experience across policy advisory, international partnerships, and enterprise scaling, Sachin will lead the global expansion of our Zero Capex GCC model, enabling enterprises across the US, Europe, and the Middle East to build future-ready AI, data, and digital engineering teams.
                                </p>
                            </div>
                        </div>

                        <div className="yb-leader-card">
                            <img src={rupeshImg} alt="Rupesh Kulkarni" className="yb-leader-img-circle" />
                            <div className="yb-leader-content">
                                <h4>Rupesh Kulkarni</h4>
                                <span className="yb-leader-role">Vice President, Delivery</span>
                                <p className="yb-leader-desc">
                                    With over 15 years of experience leading large-scale digital transformation across multiple industries, Rupesh brings strong expertise in agile delivery, global team leadership, and complex program execution. His passion for building scalable, customer-centric solutions will strengthen our delivery excellence.
                                </p>
                            </div>
                        </div>

                        <div className="yb-leader-card">
                            <img src={sushilChawlaImg} alt="Sushil Chawla" className="yb-leader-img-circle" />
                            <div className="yb-leader-content">
                                <h4>Sushil Chawla</h4>
                                <span className="yb-leader-role">Vice President, Middle East</span>
                                <p className="yb-leader-desc">
                                    With over 25 years of experience across the global BFSI landscape, Sushil brings deep expertise in digital transformation, AI-enabled solutions, and corporate banking innovation. His leadership across organizations such as Coforge, Wipro, and Barclays will be instrumental in strengthening Comsense's presence and growth across the Middle East region.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="yb-welcome-footer mx-auto mt-4" style={{ maxWidth: '900px' }}>
                        Their presence marks an important step in preparing Comsense for its next phase of expansion and impact. We look forward to shaping the future together.
                    </div>
                </Container>
            </section>

            {/* Testimonials */}
            <section className="yb-section" style={{ background: 'linear-gradient(to bottom, #eef9fe 0%, #ffffff 100%)' }}>
                <Container>
                    <div className="text-center mb-3">
                        <span className="yb-badge-soft yb-badge-soft2">
                            <FaCommentDots className="me-2 text-danger" /> Trusted Voices
                        </span>
                    </div>
                    {/* <h2 className="yb-heading mb-3">What People Say</h2>
                    <div className="yb-heading-underline"></div>
                    <p className="yb-subtitle mx-auto mb-5" style={{ maxWidth: '700px' }}>
                        Perspectives from our clients and team members
                    </p> */}

                    <h3 className="text-center fw-bold mb-4">Client Testimonials</h3>

                    <div className="mx-auto" style={{ maxWidth: '1000px' }}>
                        <div className="yb-testimonial-large">
                            <FaQuoteLeft className="yb-quote-icon-large" />
                            <p className="yb-client-text">
                                The Comsense team delivered outstanding work on the Salesforce Marketing Cloud deployment for North America, ensuring seamless execution across solution design, delivery, training, and handover. Special appreciation to Shivkumar Dusad for his dependable leadership, Rutika Bhikule for her excellence in establishing the foundation of journeys, and Sanket Chikhale for leading the IS function for our North America division with impressive results.
                            </p>
                            <div className="yb-testimonial-divider"></div>
                            <div>
                                <div className="yb-author-name">CRM Manager</div>
                                <div className="yb-author-role">Leading Global Automotive Organization</div>
                            </div>
                        </div>
                    </div>

                    <h3 className="text-center fw-bold mb-4 mt-5">Associates Speak</h3>

                    <Row className="g-4 justify-content-center">
                        <Col md={6} lg={6}>
                            <div className="yb-testimonial-card">
                                <FaQuoteLeft className="yb-quote-icon-large" />
                                <p className="yb-associate-text">
                                    My journey at Comsense Technologies has been one of continuous learning and growth. Each day brings new challenges, fresh perspectives, and meaningful opportunities to learn, adapt, and evolve through experience. Being part of a collaborative and supportive team has contributed significantly to my professional and personal development.
                                </p>
                                <div className="border-top pt-3 d-flex align-items-center">
                                    <img src={gauriImg} alt="Gauri Chitnis" className="rounded-circle me-3" style={{ width: '100px', height: '100px', objectFit: 'cover' }} />
                                    <div>
                                        <div className="yb-author-name">Gauri Chitnis</div>
                                        <div className="yb-author-role">Jr. Data Analyst</div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md={6} lg={5}>
                            <div className="yb-testimonial-card">
                                <FaQuoteLeft className="yb-quote-icon-large" />
                                <p className="yb-associate-text">
                                    It has been over a year since I joined Comsense, and my journey here has been truly fulfilling. From the outset, I was confident that this was a place where I would enjoy my work, driven by Comsense's positive and supportive culture. Over this period, I have gained substantial technical knowledge, which has contributed meaningfully to my professional growth.
                                </p>
                                <div className="border-top pt-3 d-flex align-items-center">
                                    <img src={radhaImg} alt="Radha Kulkarni" className="rounded-circle me-3" style={{ width: '100px', height: '100px', objectFit: 'cover' }} />
                                    <div>
                                        <div className="yb-author-name">Radha Kulkarni</div>
                                        <div className="yb-author-role">Front End Developer</div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Future */}
            <section className="yb-section pt-0">
                <Container>
                    <div className="text-center mb-3">
                        <span className="yb-badge-soft">
                            <FaBinoculars className="me-2 text-danger" /> Future Vision
                        </span>
                    </div>
                    <h2 className="yb-heading mb-3">Looking Ahead: 2026 & Beyond</h2>
                    <div className="yb-heading-underline"></div>
                    <p className="text-center text-muted mb-5">Our roadmap for continued growth and innovation</p>

                    <Row className="g-4 mb-5">
                        <Col md={3}>
                            <div className="yb-roadmap-card">
                                <div className="yb-roadmap-icon"><FaRocket /></div>
                                <h4>AI-Powered Deliverables</h4>
                                <p className="text-muted">Accelerate development and deployment of AI-powered deliverables, turning our AI-first vision into tangible solutions for clients.</p>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="yb-roadmap-card">
                                <div className="yb-roadmap-icon"><FaBullseye /></div>
                                <h4>Geographic & Vertical Expansion</h4>
                                <p className="text-muted">Expand footprint across geographies and verticals, especially in high-growth sectors like diagnostics, enterprise CRM, and data-driven services.</p>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="yb-roadmap-card">
                                <div className="yb-roadmap-icon"><FaUserTie /></div>
                                <h4>Talent Development</h4>
                                <p className="text-muted">Build and nurture talent in data science, AI, and domain-specific consulting to maintain competitive advantage.</p>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="yb-roadmap-card">
                                <div className="yb-roadmap-icon"><FaChartLine /></div>
                                <h4>Operational Excellence</h4>
                                <p className="text-muted">Strengthen client partnerships and operational excellence, ensuring sustainable growth and high service quality with strong governance.</p>
                            </div>
                        </Col>
                    </Row>

                    <h3 className="text-center fw-bold mb-4">What It Means for Our Stakeholders</h3>

                    <Row className="justify-content-center">
                        <Col lg={10}>
                            <div className="yb-stakeholder-card">
                                <div className="yb-stakeholder-icon"><FaBriefcase /></div>
                                <div>
                                    <h5 className="fw-bold mb-1">Clients & Partners</h5>
                                    <p className="mb-0 text-muted small">Strong growth and expanded capabilities across CRM, unified intelligence, and AI-powered solutions, delivering superior business outcomes through advanced technology and operational excellence.</p>
                                </div>
                            </div>

                            <div className="yb-stakeholder-card">
                                <div className="yb-stakeholder-icon"><FaUsers /></div>
                                <div>
                                    <h5 className="fw-bold mb-1">Employees & Talent</h5>
                                    <p className="mb-0 text-muted small">Emphasis on future-ready hiring and AI-first orientation opens doors for growth, skill development, and working on cutting-edge projects.</p>
                                </div>
                            </div>

                            <div className="yb-stakeholder-card">
                                <div className="yb-stakeholder-icon"><FaDollarSign /></div>
                                <div>
                                    <h5 className="fw-bold mb-1">Investors & Leadership</h5>
                                    <p className="mb-0 text-muted small">Strong revenue growth, major enterprise wins, and strategic investments underscore a healthy, forward-looking company trajectory.</p>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div className="yb-future-footer !text-white">
                        <p>As we close this chapter, we do so with gratitude—for the trust of our clients, the commitment of our teams, and the belief of our partners.</p>
                        <p>With clarity in vision and confidence in execution, we look ahead to 2026 and beyond—ready to grow, innovate, and create lasting impact together.</p>
                    </div>
                </Container>
            </section>

            {/* Spiritual Corner */}
            <section className="yb-section pt-2">
                <Container>
                    <div className="text-center mb-3">
                        <span className="yb-badge-soft">
                            <FaHeart className="me-2 text-danger" /> Heartfulness
                        </span>
                    </div>
                    <h2 className="yb-heading mb-5">Spiritual Corner</h2>
                    <div className="yb-heading-underline" style={{ marginTop: '-40px', marginBottom: '50px' }}></div>
                    <br></br><br></br>
                    <div className="yb-spiritual-banner">
                        <div className="position-relative">
                            <img src={daajiImg} alt="Daaji" className="mb-4 shadow-lg rounded-4" style={{ width: '350px', height: 'auto', border: '5px solid rgba(255,255,255,0.2)' }} />
                            <h2 className="fw-bold mb-3">One World, One Heart</h2>
                            <h5 className="mb-0 fw-light">A Global Moment of Stillness</h5>
                        </div>
                    </div>

                    <Row className="justify-content-center">
                        <Col lg={12}>
                            <div className="yb-spiritual-content">
                                <p className="yb-spiritual-text">
                                    On December 21, 2025, millions around the world joined the Heartfulness global meditation event, <strong className="text-danger">"One World, One Heart,"</strong> led by Daaji (Kamlesh Patel), to mark World Meditation Day.
                                </p>
                                <p className="yb-spiritual-text">
                                    People across continents paused together in guided meditation, focusing on inner connection and radiating peace. What made the moment truly special was not just the scale of participation, but the shared intention—to pause, turn inward, and contribute to a more harmonious world.
                                </p>
                                <p className="yb-spiritual-text">
                                    This global spirit of mindfulness and inner balance strongly resonates with the values practiced at Comsense. All Comsense founders follow Heartfulness, and more than 25 Comsense team members have experienced Heartfulness Meditation firsthand. In alignment with this philosophy, Comsense also conducts weekly meditation sessions, reinforcing a culture of calm, clarity, and conscious well-being in everyday professional life.
                                </p>
                                <p className="yb-spiritual-text fw-bold mb-0">
                                    One World, One Heart stood as a simple yet profound expression of what becomes possible when humanity—and organizations within it—choose to breathe, connect, and move forward together with intention.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Footer */}
            <footer className="yb-footer">
                <Container>
                    <div className="yb-footer-logo-container">
                        <div className="yb-footer-icon"><FaBuilding /></div>
                        <h3 className="fw-bold mb-0 text-white">Comsense Technologies</h3>
                    </div>

                    <div className="yb-footer-divider"></div>

                    <div className="yb-footer-year">2025 Year in Review</div>
                    <div className="yb-footer-tagline">Building tomorrow's solutions, together</div>

                    <div className="yb-footer-line"></div>

                    <div className="yb-footer-copyright">
                        &copy; 2026 Comsense Technologies. All rights reserved.
                    </div>
                </Container>
            </footer>
        </div >
    );
};

export default Yearbook05;
